'use strict';

module.exports = {
    classList: require('./class.js'),
    events: require('./events.js'),
    position: require('./position.js'),
    style: require('./css.js')
};